import { CoreModel } from '../core/core.model';
/**
 * <h4>Example of Selectable Model:</h4>
 * <pre>{{'{'}}
 * 	value: 'value',
 * 	item: any,
 * 	checked: false,
 * 	itemPosition: 'after'
 * {{'}'}}
 * </pre>
 */
export class SelectableModel extends CoreModel {
/**
 * The internal value of the selectable emitted when selected. Default: value.
 */
value?: string;
/**
 * Item can be a label or any other object based on the html template passed to the selectable.
 */
item?: any;
/**
 * Checked or not checked. Default: false.
 */
checked?: boolean;
/**
 * Item Position relative to the control. Can be: before , after. Default: after.
 */
itemPosition?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectableModel_tsickle_Closure_declarations() {
/**
 * The internal value of the selectable emitted when selected. Default: value.
 * @type {?}
 */
SelectableModel.prototype.value;
/**
 * Item can be a label or any other object based on the html template passed to the selectable.
 * @type {?}
 */
SelectableModel.prototype.item;
/**
 * Checked or not checked. Default: false.
 * @type {?}
 */
SelectableModel.prototype.checked;
/**
 * Item Position relative to the control. Can be: before , after. Default: after.
 * @type {?}
 */
SelectableModel.prototype.itemPosition;
}

